import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team';
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = () => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units); 
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const teams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if (teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };

    const administration = teams.find(x => x.id === 46);
    addUnits(administration);

    const pladsmen = teams.find(x => x.id === 45);
    addUnits(pladsmen);

    const workshop = teams.find(x => x.id === 44);
    addUnits(workshop);

    const recycle = teams.find(x => x.id === 43);
    addUnits(recycle);

    const rats = teams.find(x => x.id === 42);
    addUnits(rats);

    const sports = teams.find(x => x.id === 41);
    addUnits(sports);

    const animal = teams.find(x => x.id === 40);
    addUnits(animal);

    const garden4 = teams.find(x => x.id === 38);
    addUnits(garden4);

    const garden3 = teams.find(x => x.id === 37);
    addUnits(garden3);

    const garden2 = teams.find(x => x.id === 35);
    addUnits(garden2);

    const garden1 = teams.find(x => x.id === 34);
    addUnits(garden1);

    const buildings = teams.find(x => x.id === 32);
    addUnits(buildings);

    const vejbelysning = teams.find(x => x.id === 74);
    addUnits(vejbelysning);

    return (
        <div className="team-list">

            <div style={{width: '21%', height: '100%', float: 'left'}}>
                <Team team={garden1} width={100} height={25} className='garden-team' />
                <Team team={garden2} width={100} height={25} className='garden-team' />
                <Team team={garden3} width={100} height={25} className='garden-team' />
                <Team team={garden4} width={119} height={25} className='garden-team' />
            </div>
            
            <Team team={administration} width={29} height={75}  subTeams={[animal, sports, rats, ]}/>

            <div style={{width: '25%', height: '100%', float: 'left'}}>
                <Team team={buildings} width={100} height={37.5} hideLeader />
                <Team team={recycle} width={100} height={37.5} />
            </div>

            <Team team={workshop} width={25} height={50} subTeams={[pladsmen]} hideLeader />

            <Team team={vejbelysning} width={25} height={25} hideLeader />



            <ColorLegend />
        </div>
    );
};

export default CustomTeamList;